import React from "react";
import Dashboard from "./Dashboard";

export default function HomeSectionIndex() {
    return (
        <Dashboard/>
    );
}
